import { __awaiter } from 'tslib';
import { DynamicError } from '../../errors.js';
import { normalizeWalletName } from '../../utils/normalizeWalletName/normalizeWalletName.js';
import { SolProvider } from './solProvider.js';
import { SolProviderHelper } from './solProviderHelper.js';

class CoinbaseSolana extends SolProvider {
    constructor() {
        super(...arguments);
        this.name = 'CoinbaseSolana';
        this.supportedChains = ['SOL'];
        this.connectedChain = 'SOL';
        this.canConnectViaQrCode = false;
        this.canConnectViaCustodialService = false;
        this.isWalletConnect = false;
        this.solProviderHelper = new SolProviderHelper();
    }
    get key() {
        return normalizeWalletName(this.name);
    }
    setupEventListeners(listeners) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.solProviderHelper._setupEventListeners(listeners, this.solProviderHelper.findProvider(this.name));
        });
    }
    teardownEventListeners() {
        this.solProviderHelper._teardownEventListeners(this.name);
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.solProviderHelper.connectWithName(this.name);
        });
    }
    getSigner() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.solProviderHelper.connectWithName(this.name);
        });
    }
    isInstalledOnBrowser() {
        return this.solProviderHelper.isInstalledHelper(this.name);
    }
    fetchPublicAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInstalledOnBrowser()) {
                return this.solProviderHelper.fetchPublicAddressWithName(this.name);
            }
            return;
        });
    }
    signMessage(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.solProviderHelper.signMessageWithName(messageToSign, this.name);
        });
    }
    proveOwnership(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.signMessage(messageToSign);
        });
    }
    supportsNetworkSwitching() {
        return false;
    }
    switchNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new DynamicError('Not supported');
        });
    }
    getConnectedAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.solProviderHelper.getConnectedAccountsWithName(this.name);
        });
    }
}

export { CoinbaseSolana as default };
